import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import gql from 'graphql-tag';
import { withApollo } from 'react-apollo';
import * as Cookies from 'es-cookie';

// ── GraphQL ──────────────────────────────────
const ASSIGN_ADMISSION_TEST_AUTO = gql`
  mutation($enquiry_form_master_id: Int!, $institute_id: Int!, $branch_id: String!, $inserted_by: Int) {
    assignAdmissionTestAuto(
      enquiry_form_master_id: $enquiry_form_master_id,
      institute_id: $institute_id,
      branch_id: $branch_id,
      inserted_by: $inserted_by
    ) {
      id
      username
      password
    }
  }
`;

const AssignTestModal = ({ show, onHide, student, client }) => {
  const [assigning, setAssigning] = useState(false);
  const [credentials, setCredentials] = useState(null);
  const [error, setError] = useState('');

  const handleAssign = async () => {
    setAssigning(true);
    setError('');
    try {
      const institute_id = parseInt(Cookies.get('institutionid'));
      let branch_id = student?.branch_id;

      if (!branch_id) {
        try {
          const cookie = Cookies.get('branch_id');
          const parsed = cookie ? JSON.parse(cookie) : [];
          branch_id = parsed[0] || ""; // Fallback to first authorized branch if student has none
        } catch (e) {
          branch_id = "";
        }
      }

      const result = await client.mutate({
        mutation: ASSIGN_ADMISSION_TEST_AUTO,
        variables: {
          enquiry_form_master_id: parseInt(student?.id),
          institute_id: institute_id,
          branch_id: String(branch_id),
          inserted_by: parseInt(Cookies.get('user_id') || Cookies.get('id')),
        },
      });
      const record = result.data.assignAdmissionTestAuto;
      setCredentials({
        username: record.username,
        password: record.password,
      });
    } catch (err) {
      setError(err.message?.replace('GraphQL error: ', '') || 'Failed to auto-assign test.');
    }
    setAssigning(false);
  };

  const handleClose = () => {
    setCredentials(null);
    setError('');
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="md" dialogClassName="af-premium-modal">
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fas fa-magic mr-2"></i>
          {credentials ? '✅ Exam Generated' : 'Generate Auto Exam'}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>

        {error && (
          <div className="alert alert-danger py-2">{error}</div>
        )}

        {/* ── Step 1: Assign Confirmation ── */}
        {!credentials ? (
          <div>
            <div className="af-modal-student-summary">
              <div className="af-summary-avatar">
                <i className="fas fa-user-graduate"></i>
              </div>
              <div className="af-summary-text">
                Generate exam credentials for <br />
                <strong>{student?.student_name}</strong>
              </div>
            </div>

            <p className="text-muted small mb-4">
              Clicking generate will automatically map this student to the active admission exam for their branch and provide login credentials.
            </p>

            <button
              className="btn btn-primary btn-block"
              style={{
                height: '48px',
                borderRadius: '12px',
                background: '#1e3a8a',
                border: 'none',
                fontWeight: '600',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }}
              onClick={handleAssign}
              disabled={assigning}
            >
              {assigning ? (
                <>
                  <span className="spinner-border spinner-border-sm" />
                  Generating...
                </>
              ) : (
                <>
                  <i className="fas fa-cog"></i> Generate Exam Now
                </>
              )}
            </button>
          </div>

        ) : (

          /* ── Step 2: Show credentials ── */
          <div>
            <div className="af-modal-student-summary mb-3">
              <div className="af-summary-avatar" style={{ background: '#f0fdf4', color: '#16a34a' }}>
                <i className="fas fa-check"></i>
              </div>
              <div className="af-summary-text">
                Success! Exam generated for <br />
                <strong>{student?.student_name}</strong>
              </div>
            </div>

            <div className="af-cred-card">
              <div className="af-cred-item">
                <span className="af-cred-label">Username</span>
                <div className="d-flex align-items-center">
                  <span className="af-cred-value mr-3">{credentials.username}</span>
                  <button
                    className="af-mini-icon-btn"
                    onClick={() => {
                      navigator.clipboard.writeText(credentials.username);
                      alert('Username copied!');
                    }}
                    title="Copy Username"
                  >
                    <i className="far fa-copy"></i>
                  </button>
                </div>
              </div>

              <div className="af-cred-item">
                <span className="af-cred-label">Password</span>
                <div className="d-flex align-items-center">
                  <span className="af-cred-value mr-3">{credentials.password}</span>
                  <button
                    className="af-mini-icon-btn"
                    onClick={() => {
                      navigator.clipboard.writeText(credentials.password);
                      alert('Password copied!');
                    }}
                    title="Copy Password"
                  >
                    <i className="far fa-copy"></i>
                  </button>
                </div>
              </div>

              <div className="af-cred-item" style={{ borderBottom: 'none', paddingBottom: 0 }}>
                <span className="af-cred-label">Exam Link</span>
                <div className="d-flex align-items-center">
                  <a href={`${window.location.origin}/admission-test`} target="_blank" rel="noopener noreferrer" className="af-cred-value text-primary mr-3" style={{ textDecoration: 'underline' }}>
                    Open Link
                  </a>
                  <button
                    className="af-mini-icon-btn"
                    onClick={() => {
                      navigator.clipboard.writeText(`${window.location.origin}/admission-test`);
                      alert('Link copied!');
                    }}
                    title="Copy Link"
                  >
                    <i className="fas fa-link"></i>
                  </button>
                </div>
              </div>
            </div>

            <button
              className="btn btn-outline-secondary btn-block mt-4"
              style={{ borderRadius: '12px', height: '44px', fontWeight: '600' }}
              onClick={handleClose}
            >
              Done
            </button>
          </div>
        )}

      </Modal.Body>
    </Modal>
  );
};

export default withApollo(AssignTestModal);
